export const ADD_NEW_SIGNATORY_STARTED = "ADD_NEW_SIGNATORY_STARTED";
export const ADD_NEW_SIGNATORY_SUCCEEDED = "ADD_NEW_SIGNATORY_SUCCEEDED";
export const ADD_NEW_SIGNATORY_FAILED = "ADD_NEW_SIGNATORY_FAILED";
export const DELETE_SIGNATORY = "DELETE_SIGNATORY";
export const SET_INDUSTRY = "SET_INDUSTRY";
export const SET_ROLE = "SET_ROLE";
export const SET_BUSINESS_DETAILS = "SET_BUSINESS_DETAILS";
export const ADD_SHAREHOLDERS_STARTED = "ADD_SHAREHOLDERS_STARTED";
export const ADD_SHAREHOLDERS_SUCCEEDED = "ADD_SHAREHOLDERS_SUCCEEDED";
export const ADD_SHAREHOLDERS_FAILED = "ADD_SHAREHOLDERS_FAILED";
export const ADD_TO_SHAREHOLDERS_SCHEMA = "ADD_TO_SHAREHOLDERS_SCHEMA";
export const SET_ADD_SIGNATORY_ROLE = "SET_ADD_SIGNATORY_ROLE";
export const SET_SIGNATORY_EDIT_INFO = "SET_SIGNATORY_EDIT_INFO";
export const UPDATE_TRANSACTION_PIN_STARTED = "UPDATE_TRANSACTION_PIN_STARTED";
export const UPDATE_TRANSACTION_PIN_SUCCEEDED =
    "UPDATE_TRANSACTION_PIN_SUCCEEDED";
export const UPDATE_TRANSACTION_PIN_FAILED = "UPDATE_TRANSACTION_PIN_FAILED";
export const GET_LIMIT_LIST_STARTED = "GET_LIMIT_LIST_STARTED";
export const GET_LIMIT_LIST_SUCCEEDED = "GET_LIMIT_LIST_SUCCEEDED";
export const GET_LIMIT_LIST_FAILED = "GET_LIMIT_LIST_FAILED";
export const UPDATE_TRANSACTION_LIMIT_STARTED =
    "UPDATE_TRANSACTION_LIMIT_STARTED";
export const UPDATE_TRANSACTION_LIMIT_SUCCEEDED =
    "UPDATE_TRANSACTION_LIMIT_SUCCEEDED";
export const UPDATE_TRANSACTION_LIMIT_FAILED =
    "UPDATE_LIMIUPDATE_TRANSACTION_LIMIT_FAILEDT_LIST_FAILED";
export const DELETE_SIGNATORY_STARTED = "DELETE_SIGNATORY_STARTED";
export const DELETE_SIGNATORY_SUCCEEDED = "DELETE_SIGNATORY_SUCCEEDED";
export const DELETE_SIGNATORY_FAILED = "DELETE_SIGNATORY_FAILED";
export const FETCH_SIGNATORIES_STARTED = "FETCH_SIGNATORIES_STARTED";
export const FETCH_SIGNATORIES_SUCEEDED = "FETCH_SIGNATORIES_SUCEEDED";
export const FETCH_SIGNATORIES_FAILED = "FETCH_SIGNATORIES_FAILED";
export const DISABLE_SIGNATORY_STARTED = "DISABLE_SIGNATORY_STARTED";
export const DISABLE_SIGNATORY_SUCCEEDED = "DISABLE_SIGNATORY_SUCCEEDED";
export const DISABLE_SIGNATORY_FAILED = "DISABLE_SIGNATORY_FAILED";
export const UPDATE_NEWSIGNATORY_SUCCEEDED = "UPDATE_NEWSIGNATORY_SUCCEEDED"
export const INITIATE_PIN_RESET_STARTED = "INITIATE_PIN_RESET_STARTED";
export const INITIATE_PIN_RESET_FAILED = "INITIATE_PIN_RESET_FAILED"
export const INITIATE_PIN_RESET_SUCCEEDED = "INITIATE_PIN_RESET_SUCCEEDED"
export const VALIDATE_RESET_PIN_STARTED = "VALIDATE_RESET_PIN_STARTED";
export const VALIDATE_RESET_PIN_FAILED = "VALIDATE_RESET_PIN_FAILED";
export const VALIDATE_RESET_PIN_SUCCEEDED = "VALIDATE_RESET_PIN_SUCCEEDED";
export const ADD_NEW_NOMINEE_STARTED = "ADD_NEW_NOMINEE_STARTED";
export const ADD_NEW_NOMINEE_SUCCEEDED = "ADD_NEW_NOMINEE_SUCCEEDED";
export const ADD_NEW_NOMINEE_FAILED = "ADD_NEW_NOMINEE_FAILED";
export const EDIT_NOMINEE_STARTED = "EDIT_NOMINEE_STARTED";
export const EDIT_NOMINEE_SUCCEEDED = "EDIT_NOMINEE_SUCCEEDED";
export const EDIT_NOMINEE_FAILED = "EDIT_NOMINEE_FAILED";
export const SET_NOMINEE_EDIT_INFO = "SET_NOMINEE_EDIT_INFO";
export const FETCH_INVITED_NOMINEES_STARTED="FETCH_INVITED_NOMINEES_STARTED";
export const FETCH_INVITED_NOMINEES_SUCCEEDED="FETCH_INVITED_NOMINEES_SUCCEEDED";
export const FETCH_INVITED_NOMINEES_FAILED="FETCH_INVITED_NOMINEES_FAILED";
export const FETCH_TEAMMATES_STARTED="FETCH_TEAMMATES_STARTED";
export const FETCH_TEAMMATES_SUCCEEDED="FETCH_TEAMMATES_SUCCEEDED";
export const FETCH_TEAMMATES_FAILED="FETCH_TEAMMATES_FAILED";
export const DELETE_NOMINEE_STARTED = "DELETE_NOMINEE_STARTED";
export const DELETE_NOMINEE_SUCCEEDED = "DELETE_NOMINEE_SUCCEEDED";
export const DELETE_NOMINEE_FAILED = "DELETE_NOMINEE_FAILED";
